import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "../api/baseurl";
import { Modal, Button, Form } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const CreateFinancialYear = ({ isOpen, onRequestClose }) => {
  const [fromMonth, setFromMonth] = useState("");
  const [toMonth, setToMonth] = useState("");
  const [loading, setLoading] = useState(false);
  const [financialYearId, setFinancialYearId] = useState(null);

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const navigate = useNavigate();

  const getFinancialYearData = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      setLoading(true);
      const response = await axios.get("/api/year-settings", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (Array.isArray(response.data) && response.data.length > 0) {
        const { id, fromDate, toDate } = response.data[0];
        if (id) {
          setFinancialYearId(id);
          setFromMonth(fromDate);
          setToMonth(toDate);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getFinancialYearData();
    }
  }, [isOpen]);

  const handleStartMonthChange = (e) => {
    const selectedMonthIndex = parseInt(e.target.value) - 1;
    const selectedMonth = months[selectedMonthIndex];
    setFromMonth(selectedMonth);
    const calculatedEndMonthIndex = selectedMonthIndex === 0 ? 11 : selectedMonthIndex - 1;
    setToMonth(months[calculatedEndMonthIndex]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;
      if (financialYearId) {
        await axios.post(`/api/year-settings/update`, {
          id: financialYearId,
          fromDate: fromMonth,
          toDate: toMonth,
        }, { headers: { Authorization: `Bearer ${token}` } });
        toast.success("Financial year updated successfully");
      } else {
        await axios.post("/api/year-settings/create", {
          fromDate: fromMonth,
          toDate: toMonth,
        }, { headers: { Authorization: `Bearer ${token}` } });
        toast.success("Financial year created successfully");
      }
      setLoading(false);
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">calendar_today</i>
          {financialYearId ? "Update Financial Year" : "Create Financial Year"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <Form onSubmit={handleSubmit}>
          <div className="mb-3">
            <Form.Label className="small fw-semibold">From Month <span className="text-danger">*</span></Form.Label>
            <Form.Control
              as="select"
              value={months.indexOf(fromMonth) + 1}
              onChange={handleStartMonthChange}
              required
            >
              <option value="">Select Starting Month</option>
              {months.map((month, index) => (
                <option key={index} value={index + 1}>{month}</option>
              ))}
            </Form.Control>
          </div>

          {toMonth && (
            <div className="mb-4">
              <Form.Label className="small fw-semibold">To Month (Auto-calculated)</Form.Label>
              <Form.Control type="text" value={toMonth} readOnly className="bg-light fw-bold text-primary" />
            </div>
          )}

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>{financialYearId ? "edit" : "save"}</i>
              {financialYearId ? "Update Year" : "Save Year"}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateFinancialYear;
